import { Button, Progress } from 'antd'
import React from 'react'

function Header({formatMessage, questions = [], onReset = () => {}, answers = {}}) {
  if(questions.length < 2){
    return <div></div>;
  }

  console.log("🚀 ~ Header ~ answers:", answers)

  const count = answers.filter(_i => _i != null).length;


  return (
    <div className='QuestionViewHeader'>
      <Progress percent={100/questions.length * count} showInfo={false} />
      <div className='text-count'>{count}/{questions.length}</div>
      <Button onClick={onReset}>{formatMessage('btnResetQuestions')}</Button>
    </div>
  )
}

export default Header


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Header/Header.jsx